"use strict";
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
// TODO: import old code from transition-legacy
Object.defineProperty(exports, "__esModule", { value: true });
exports.metersToPixels = exports.metersToMapboxPixelsAtMaxZoom = exports.geojsonToPolyBoundary = void 0;
const geojsonToPolyBoundary = function (geojson) {
    let geojsonPolygonGeom;
    if (geojson.type === 'FeatureCollection') {
        if (!geojson.features ||
            geojson.features.length === 0 ||
            !geojson.features[0] ||
            geojson.features[0].geometry.type !== 'Polygon') {
            console.error('featureCollection is empty or invalid, or first feature is not a Polygon');
            return false;
        }
        geojsonPolygonGeom = geojson.features[0].geometry;
    }
    else if (geojson.type === 'Feature') {
        if (geojson.geometry.type !== 'Polygon') {
            console.error('feature is not a Polygon');
            return false;
        }
        geojsonPolygonGeom = geojson.geometry;
    }
    else {
        geojsonPolygonGeom = geojson;
    }
    const outerCoordinates = geojsonPolygonGeom.coordinates[0];
    const polyBoundaryArray = [];
    for (let i = 0, count = outerCoordinates.length; i < count; i++) {
        polyBoundaryArray.push(`${outerCoordinates[i][1]} ${outerCoordinates[i][0]}`);
    }
    return polyBoundaryArray.join(' ');
};
exports.geojsonToPolyBoundary = geojsonToPolyBoundary;
const metersToMapboxPixelsAtMaxZoom = function (meters, latitude) {
    return meters / 0.075 / Math.cos((latitude * Math.PI) / 180);
};
exports.metersToMapboxPixelsAtMaxZoom = metersToMapboxPixelsAtMaxZoom;
const metersPerPixel = function (latitude, zoom) {
    const earthCircumference = 40075017;
    const latitudeRadians = latitude * (Math.PI / 180);
    return (earthCircumference * Math.cos(latitudeRadians)) / Math.pow(2, zoom + 8);
};
const metersToPixels = function (meters, latitude, zoom) {
    if (Math.abs(latitude) > 90) {
        return Number.NaN;
    }
    return meters / metersPerPixel(latitude, zoom);
};
exports.metersToPixels = metersToPixels;
//# sourceMappingURL=ConversionUtils.js.map